import axios from "axios";
import { getHeaders } from "../utils/helpers/main";
import endpoints from "./endpoints";

export const getCSRApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.csrFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const updateCSRField = async (data) => {
  const callResponse = await axios({
    url: endpoints.csrUpdate,
    method: "PATCH",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getCSRStatusCountApi = async params => {
    const callResponse = await axios({
      url: endpoints.csrCount,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then(response => response.data)
      .catch(err => err.response.data);
  
    return callResponse;
  };
  

export default getCSRApi;
